module.exports = __webpack_public_path__ + "img/main-background-left.3c33bcce.png";